import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { adminService } from '../services/adminService';
import { findNavItem, ROUTE_META } from '../ui/AppShell/navigation';

/** The page's name as the menu shows it ("Fleet Manager"), else the path itself. */
export const pageLabel = (pathname) => {
    const item = findNavItem(pathname);
    if (item) return item.group ? `${item.group} · ${item.label}` : item.label;
    const meta = ROUTE_META.find((m) => (m.path.endsWith('/') ? pathname.startsWith(m.path) : pathname === m.path));
    return meta ? meta.label : pathname;
};

/**
 * Every page (and page tab) a signed-in user opens is one line of the activity log (owner, 20 Oct 2026: "يسجل كل
 * حاجه بيعملها اى يوزر" - the changes are logged by the engine itself, api/activity_trail.py). Only the path and its
 * ?tab= count: a page that writes its filters into the URL does not log every keystroke. Renders nothing.
 */
export default function PageViewLogger() {
    const { pathname, search } = useLocation();
    const { currentUser } = useAuth();
    const last = useRef('');
    const tab = new URLSearchParams(search).get('tab') || '';

    useEffect(() => {
        if (!currentUser || pathname === '/login' || pathname === '/') return;     // "/" only sends on to the start page
        const key = `${currentUser.uid}|${pathname}|${tab}`;
        if (key === last.current) return;          // the same page again (a re-render, a filter in the URL)
        last.current = key;
        const label = pageLabel(pathname);
        adminService.logUserAction('OPEN_PAGE', `Opened ${label}${tab ? ` (tab ${tab})` : ''}`, currentUser,
            { source: 'web', path: pathname, ...(tab ? { tab } : {}) });
    }, [currentUser, pathname, tab]);

    return null;
}
